import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    title: {
      color: variables.black50,
      textAlign: 'start',
    },
    root: {
      flexGrow: 1,
      paddingInlineEnd: 56,
      paddingInlineStart: 56,

      '@media (max-width: 1180px)': {
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
      },
    },
    emptyReportMessageContainer: {
      marginTop: 193,
    },
    inactiveClients: {
      marginTop: 26,
      marginBottom: 32,
      marginInlineStart: 8,
    },
    cell: {
      minWidth: 153,
      maxWidth: 153,
      padding: '6px 16px',
    },
    emptyCell: {
      minWidth: 65,
      maxWidth: 65,
      width: 65,
    },
    formControl: {
      width: '100%',
    },
    mobileContainer: {
      '@media (min-width: 1181px)': {
        display: 'none',
        marginBottom: 20,
      },
    },
    clientAllocation: {
      marginTop: 140,
    },
    allocationTitle: {
      marginTop: 10,
      marginBottom: 10,
      fontWeight: 600,
      fontSize: 16,
      color: variables.richBlack,
    },
    allocationText: {
      width: 374,
      fontWeight: 400,
      fontSize: 16,

      '@media (max-width: 420px)': {
        width: '100%',
      },
    },
    sendEmailBtn: {
      gap: 16,
      paddingLeft: 16,
      paddingRight: 16,
      border: 'none',
      height: 56,
      color: `${variables.richBlack} !important;`,
      'font-weight': '600 !important;',
      fontSize: '16px !important;',
      marginInlineEnd: 10,

      '&:hover': {
        color: `${variables.black50} !important;`,
        backgroundColor: 'unset',
      },
    },
  }),
);
